module.exports = __webpack_public_path__ + "static/media/1.8b294244.svg";